export default function OrgTerms() {
    return (
        <div>
            <h1>Organizder Terms and Conditions</h1>
        </div>
    );
}
